import React, { useState } from "react";
import Portals from "./portals";
import CompanyProfile from "./company-profile";
import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useTranslation } from "react-i18next";
import GenerateApiKey from "./generate-api-key";
import "./settings.css";
import ImageOrderManager from "./image-order-manager";

const Settings: React.FunctionComponent<{}> = (props) => {

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const { t } = useTranslation();


    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const changeMessageHandler = (color: string, msg: string) => {
        setColorSnackbar(color)
        setOpenSnackbar(true)
        setMessage(msg)
    }


    return (

        <div className="container-xxl flex-grow-1 container-p-y  ">

            <h1 className="title-30 title-24-mb mb-3 bold-900">
                Integration Hub
            </h1>

            <p className="para-16 color-39393B">
                Your integration Hub, where you can link with Portals, CRMs and Website.
            </p>

            <Portals onChangeMessagehandler={changeMessageHandler} />

            <GenerateApiKey onChangeMessagehandler={changeMessageHandler} />

            <ImageOrderManager onChangeMessagehandler={changeMessageHandler} />

            <CompanyProfile onChangeMessagehandler={changeMessageHandler} />

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar} autoHideDuration={6000}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

        </div>

    )
}
export default Settings
